import axios from "axios";
import { AuthTokens } from "../../Types";
import { getAccessToken, getRefreshToken } from "../helpers/HelperFunction";
import toast from "react-hot-toast";
import { handleRefreshToken } from "../helpers/RefreshTokenHelper/tokenHelper";

export const API = axios.create({
  baseURL: import.meta.env.VITE_ADMIN_BASE_URL,
});
console.log(import.meta.env.VITE_ADMIN_BASE_URL)
export const authAPI = axios.create({
  baseURL: import.meta.env.VITE_REST_BASE_URL_V3,
});

export const webappRestAPI = axios.create({
  baseURL: import.meta.env.VITE_WEBAPP_REST_SERVER_URL,
});
const authTokensString = localStorage.getItem("authTokens");
const token: AuthTokens | null = authTokensString
  ? JSON.parse(authTokensString)
  : null;

export const refreshToken = () => {
  //cookies 2

  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${getRefreshToken()}`;

  return axios
    .post(`${import.meta.env.VITE_ADMIN_BASE_URL}/auth/refresh-token`)
    .then((response: any) => {
      //cookies 1
      localStorage.setItem("authTokens", JSON.stringify(response.data.data));
    })
    .catch((error: any) => {
      toast.error("Session Expired!. Please login again!");
      throw error;
      console.log(error);
    });
};

API.interceptors.request.use(
  async req => {
    //cookies =block
    if (token) {
      // const token = JSON.parse(localStorage.getItem("authTokens"));
      if (getAccessToken()) {
        req.headers.Authorization = `Bearer ${getAccessToken()}`;
      } else {
        req.headers.Authorization = `Bearer ${token.token}`;
      }
    }
    return req;
  },
  error => {
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    if (error.response && error.response.status === 401) {
      try {
        await handleRefreshToken();
        const newToken = getAccessToken();

        // Retry the failed request
        error.config.headers["Authorization"] = `Bearer ${newToken}`;
        return axios.request(error.config);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    } else if (error.response && error.response.status === 409) {
      localStorage.clear();
      localStorage.removeItem("authTokens");
      localStorage.removeItem("admin");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);
authAPI.interceptors.request.use(
  async req => {
    //cookies =block
    if (token) {
      // const token = JSON.parse(localStorage.getItem("authTokens"));
      if (getAccessToken()) {
        req.headers.Authorization = `Bearer ${getAccessToken()}`;
      } else {
        req.headers.Authorization = `Bearer ${token.token}`;
      }
    }
    return req;
  },
  error => {
    return Promise.reject(error);
  }
);
authAPI.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    if (error.response && error.response.status === 401) {
      try {
        await handleRefreshToken();
        const newToken = getAccessToken();

        // Retry the failed request
        error.config.headers["Authorization"] = `Bearer ${newToken}`;
        return axios.request(error.config);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    } else if (error.response && error.response.status === 409) {
      localStorage.clear();
      localStorage.removeItem("authTokens");
      localStorage.removeItem("admin");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);






// NEW SERVER V3 API's
export const RegisterAdminWithDescription = (formData: any) => 
  authAPI.post(`/admin/register-user`, formData);


export const ResendingInvitationV3 = (email: string) =>
  authAPI.post(`/admin/resend-confirmation-email`, {
    email: `${email}`,
  });
export const setPasswordNewUserV3 = (formData: any) => 
  authAPI.post(`/auth/verify-new-user`, formData);
// OLD SERVER V2 API's



export const deleteMasjidMedia = (mediaId: string, masjidId: string) =>
  API.delete(`/media/${masjidId}/delete/` + mediaId);

export const fetchLatestUpdatedEvents = (limit: number, page: number) =>
  API.get(`/event/get-latest-edited-events`, {
    params: {
      limit: `${limit}`,
      page: `${page}`,
    },
  });



type formDataType = {
  email: string;
  password: string;
};
export const LoginAdmin = (formData: formDataType, captcha: string) =>
  authAPI.post(`/auth/login`, formData, {
    params: {
      "g-recaptcha-response": captcha,
    },
  });




export const VerifyingTwoFactorAuth = (formData: any) =>
  API.post(`/auth/two-factor-auth/verify`, formData);
export const ActivatingTwoFactorAuth = () =>
  API.put(`/auth/two-factor-auth/activate`);
export const ResetGoogleAuth = (email: string) =>
  API.put(`/auth/two-factor-reset/reset`, null, {
    params: {
      email: email,
    },
  });


export const ResetGoogleVerify = (formData: any) =>
  API.put(`/auth/two-factor-reset/verify-otp`, formData);
export const getAllAdmin = () => API.get(`/admin/get-all-admins`);





export const ForgotPassword = (formData: any) =>
  webappRestAPI.post(`/v3/auth/password/forgot`, formData);
export const ResetPassword = (formData: any) =>
  webappRestAPI.post(`/v3/auth/password/reset`, formData);
export const triggeringAnnouncement = (formData: any) =>
  authAPI.post(`/notification/announcement`, formData);
export const updateAnnouncement = (announcementId: string, formData: any) =>  
  authAPI.put(`/notification/announcement/update/${announcementId}`, formData);
export const deleteAnnouncement = (announcementId: string) =>  
  authAPI.delete(`/notification/announcement/delete/${announcementId}`);

export const triggeringAnnouncementOTPVerifier = (otp: { otp: string }) =>
  authAPI.post(`/notification/announcement/verify`, otp);
export const fetchingAnnouncement = () =>
  authAPI.get(`/notification/announcement/get`);
